export enum ProductType {
  Tournament = 'Tournament',
  Subscription = 'Subscription',
  MonthlySupporter = 'MonthlySupporter',
  AnnualSupporter = 'AnnualSupporter'
}
